module.exports = __webpack_public_path__ + "img/application.0cd7f50c.png";